export const PEP_CREDENTIAL_ISSUE_KEYS = {
  wrongPassword: 'wrongPassword',
  changePassword: 'changePassword'
}

/** Server-side kinds from api-pms-receiver checkup sync. */
export const PEP_CREDENTIAL_ISSUE_KIND = {
  WrongPassword: 'WrongPassword',
  ChangePassword: 'ChangePassword'
}

const INCORRECT_MARKERS = [
  'user id or password seems to be incorrect',
  'userid or password seems to be incorrect',
  'your user id or password is incorrect',
  'invalid user id or password',
  'invalid userid or password',
  'hilton rejected the username or password'
]

const CHANGE_PASSWORD_MARKERS = [
  'password expiring',
  'password will expire',
  'password has expired',
  'change your password',
  'must change your password',
  'hilton showed password expiring'
]

/**
 * Classifies a stored PEP credential LastFailureReason into a CSM issue key.
 * Matches Hilton Lobby markers and legacy desktop paraphrases.
 * Wrong password takes precedence when both sets match.
 *
 * @param {string | null | undefined} lastFailureReason
 * @returns {'wrongPassword' | 'changePassword' | null}
 */
export function classifyPepCredentialFailureReason(lastFailureReason) {
  if (!lastFailureReason || typeof lastFailureReason !== 'string') {
    return null
  }

  const lower = lastFailureReason.toLowerCase()

  if (INCORRECT_MARKERS.some(marker => lower.includes(marker))) {
    return PEP_CREDENTIAL_ISSUE_KEYS.wrongPassword
  }

  if (CHANGE_PASSWORD_MARKERS.some(marker => lower.includes(marker))) {
    return PEP_CREDENTIAL_ISSUE_KEYS.changePassword
  }

  return null
}

/**
 * Parses Hilton "expire in N days" from a stored LastFailureReason.
 *
 * @param {string | null | undefined} lastFailureReason
 * @returns {number | null}
 */
export function parsePasswordExpireDays(lastFailureReason) {
  if (!lastFailureReason || typeof lastFailureReason !== 'string') {
    return null
  }

  const match = lastFailureReason.match(/expire\s+in\s+(\d+)\s*days?/i)
  if (!match) {
    return null
  }

  const days = Number(match[1])
  return Number.isFinite(days) && days >= 0 ? days : null
}

/**
 * Resolves CSM credential issue from list-level API fields.
 * Prefers PepCredentialIssueKind when present; falls back to reason text.
 *
 * @param {{ pepCredentialIssueKind?: string, pepCredentialLastFailureReason?: string } | null | undefined} row
 * @returns {'wrongPassword' | 'changePassword' | null}
 */
export function resolvePepCredentialIssueFromRow(row) {
  const kind = row?.pepCredentialIssueKind || row?.PepCredentialIssueKind
  if (kind === PEP_CREDENTIAL_ISSUE_KIND.WrongPassword) {
    return PEP_CREDENTIAL_ISSUE_KEYS.wrongPassword
  }
  if (kind === PEP_CREDENTIAL_ISSUE_KIND.ChangePassword) {
    return PEP_CREDENTIAL_ISSUE_KEYS.changePassword
  }

  const reason =
    row?.pepCredentialLastFailureReason || row?.PepCredentialLastFailureReason
  return classifyPepCredentialFailureReason(reason)
}
